/* DUO menu page (sections/duo-menu.liquid; Paul, Oct 27: "pick a menu, tap Add, checkout").

   Tabs: the menu rides in the address (?menu=collagen). A tab tap swaps the panel in place,
   pushes the address (Back steps through tabs) and only moves the page when the tap came from
   the sticky pill bar, to put the new panel's top under it (she asked for it with the tap).
   Menu nav (Oct 28): two sets of tabs share data-duo-tab and stay in sync: the category cards
   (the picker under the headline) and the pill bar, which shows only once the cards have
   scrolled away (an overlay: nothing moves). Header quick links (a[data-duo-qlink], the
   dropdown and the phone drawer) switch the tab in place on this page.

   A card: "Add" puts the finished drink in the cart in one tap (its first build, no Plus Ones,
   one can). Anywhere else on the card opens the drink sheet (?drink=<key>, so Back closes it):
   build, at most four Plus Ones (her menu's), 1 / 3 / 6, What's in it, Add.

   The cart lines are EXACTLY the drink page's (assets/duo-builder.js, Builder.prototype.add):
     drink    { Build or _Build, Plus Ones?, Swirl?, Caffeine, _Recipe, _build }
     Plus One { Mixed into, _build, Swirl? }        Little { Paired with, _build }
   so the cart (snippets/cart-products.liquid, assets/duo.js tidyCart), "one is on us" and the
   can labels (docs/ops/order-printer/can-labels.liquid) read them the same way.

   After an add, the confirmation: the drink, "Add 5 more, delivery is on us" (the build again
   at six cans: the old lines out, the six in, same _build, like the drink page's edit), "One for
   them" (a Little), then Checkout (members) or See your price (visitors: Shopify's sign-in, back
   to the cart; the lines are kept on the device as duo:pending, and add up across drinks).

   Prices are for members: a visitor's JSON carries 0 and money() prints nothing.
   Preview mode: a Draft drink (live: false) runs every step but never touches the cart. */
(function () {
  if (window.__duoMenu) return;
  window.__duoMenu = true;
  var root = document.querySelector('[data-duo-menu]');
  var dataEl = document.getElementById('duo-menu-json');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P1 = [];
  try { P1 = JSON.parse((document.getElementById('duo-plusones') || {}).textContent || '[]'); } catch (e) { P1 = []; }
  var GUEST = document.documentElement.hasAttribute('data-duo-guest');
  var SEE = D.see && !GUEST;
  var NAME = { low: 'Low Key', high: 'High Key' };
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MENUS = {};
  (D.menus || []).forEach(function (m) { MENUS[m.key] = m; });

  function money(c) {
    if (!SEE) return '';
    var v = c / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function buildId() { return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function post(path, body) {
    return fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function cartJs() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function p1(h) { return P1.filter(function (a) { return a.handle === h; })[0]; }
  function $(sel, el) { return (el || root).querySelector(sel); }
  function readPending() {
    try {
      var p = JSON.parse(localStorage.getItem('duo:pending') || 'null');
      return p && Array.isArray(p.ids) && Array.isArray(p.items) && Date.now() - p.at < 72e5 ? p : null;
    } catch (e) { return null; }
  }
  function writePending(v) { try { localStorage.setItem('duo:pending', JSON.stringify(v)); } catch (e) { /* the cart still has it */ } }
  function signIn(ret) {
    window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(ret || '/cart');
  }
  // the header's cart count is cans, never Plus Ones (sections/duo-header.liquid)
  function headerCount(c) {
    var n = 0;
    (c.items || []).forEach(function (i) { if (i.product_type !== 'Plus One') n += i.quantity; });
    var a = document.querySelector('.duo-top__cart');
    if (!a) return;
    var s = a.querySelector('.duo-top__count');
    if (!s && n) { s = document.createElement('span'); s.className = 'duo-top__count'; a.appendChild(s); }
    if (s) { s.textContent = String(n); s.hidden = !n; }
    a.setAttribute('aria-label', 'Cart, ' + n + ' items');
  }

  /* ---------- tabs ---------- */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-duo-tab]'));
  var bar = $('.duo-menu__tabbar');
  var cats = $('.duo-menu__cats');
  var pills = $('.duo-menu__tabs');
  function keys() {
    var out = [];
    tabs.forEach(function (t) { if (out.indexOf(t.dataset.duoTab) < 0) out.push(t.dataset.duoTab); });
    return out;
  }
  /* Horizon scrolls .page-wrapper on desktop and the window on phones; the header scrolls away
     with the page, so the tab row sticks to the very top of whichever one scrolls. */
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    return pw && pw.scrollHeight > pw.clientHeight + 1 && /auto|scroll/.test(getComputedStyle(pw).overflowY) ? pw : document.scrollingElement || document.documentElement;
  }
  function setMenu(k, push) {
    if (keys().indexOf(k) < 0) k = keys()[0];
    var was = root.dataset.menu;
    var sc = scroller(), base = sc === document.scrollingElement || sc === document.documentElement ? 0 : sc.getBoundingClientRect().top;
    var stuck = bar && root.classList.contains('is-stuck');
    root.dataset.menu = k;
    tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.duoTab === k)); });
    // keep the picked card and the picked pill in view in their sideways rows (sideways only, never the page)
    tabs.filter(function (t) { return t.dataset.duoTab === k; }).forEach(function (on) {
      var nav = on.parentNode;
      if (!nav || nav.scrollWidth <= nav.clientWidth + 1) return;
      var pad = parseFloat(getComputedStyle(nav).paddingLeft) || 0;
      var l = on.offsetLeft - nav.offsetLeft, r = l + on.offsetWidth;
      if (l - pad < nav.scrollLeft || r > nav.scrollLeft + nav.clientWidth) nav.scrollLeft = Math.max(0, l - pad);
    });
    if (push && was !== k) {
      var q = new URLSearchParams(location.search);
      q.set('menu', k); q.delete('drink');
      history.pushState({ duoMenu: k }, '', location.pathname + '?' + q.toString());
    }
    if (stuck && was !== k) {
      var panel = root.querySelector('[data-panel="' + k + '"]');
      // the panel's first line 16 px under the bar (its top padding goes under the bar, so the cards stay gone and
      // the bar stays)
      if (panel) sc.scrollTo({ top: panel.getBoundingClientRect().top + (parseFloat(getComputedStyle(panel).paddingTop) || 0) - base + sc.scrollTop - bar.offsetHeight - 16, behavior: 'instant' });
    }
  }
  // the pill bar's last pill fades at the edge while the row goes on
  function tabFade() {
    if (!pills) return;
    pills.classList.toggle('is-more', pills.scrollWidth - pills.clientWidth - pills.scrollLeft > 4);
  }
  if (pills) {
    tabFade();
    pills.addEventListener('scroll', tabFade, { passive: true });
    window.addEventListener('resize', tabFade, { passive: true });
  }
  /* the sticky pill bar comes once the cards have gone under where it sits (their bottom above the bar's
     height), and goes when they come back; it is inert and hidden from screen readers while it is away */
  (function sticky() {
    if (!bar || !cats || !('IntersectionObserver' in window)) return;
    // the row's own bottom padding (8 px on a snap row, room for a focus ring) counts as part of the bar's height
    var h = (parseFloat(getComputedStyle(root).getPropertyValue('--mbar')) || 72) + (parseFloat(getComputedStyle(cats).paddingBottom) || 0);
    function set(on) {
      root.classList.toggle('is-stuck', on);
      if (on) { bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden'); tabFade(); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    }
    new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      set(!e.isIntersecting && e.boundingClientRect.bottom < h + 1);
    }, { rootMargin: '-' + h + 'px 0px 0px 0px', threshold: 0 }).observe(cats);
  })();
  tabs.forEach(function (t) {
    t.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      setMenu(t.dataset.duoTab, true);
    });
  });

  // the tab the address opened (set before the first paint by the section's inline script)
  setMenu(root.dataset.menu, false);

  /* the header's quick links (sections/duo-header.liquid: the dropdown, the phone drawer) switch the tab in place
     here: no reload; the drawer and the dropdown close; from the keyboard, focus goes to the picked card */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-duo-qlink]') : null;
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var k = a.getAttribute('data-duo-qlink');
    if (keys().indexOf(k) < 0) return;
    e.preventDefault();
    var det = a.closest('details');
    if (det) det.removeAttribute('open');
    if (window.duoMenuDropClose) window.duoMenuDropClose();
    setMenu(k, true);
    if (e.detail === 0) {
      var c = cats && cats.querySelector('[data-duo-tab="' + k + '"]');
      if (c) c.focus();
    }
  });

  /* ---------- the v3 field: coral over paper, its seam through the banner (assets/duo.js duoLayers) ----------
     70% down the banner on desktop, 78% on phones (spec comps-v3.html #menu) */
  (function field() {
    var b = $('.duo-menu__banner');
    if (!b || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 600px)');
    function at() {
      b.setAttribute('data-duo-ly-at', mq.matches ? '0.5,0.78' : '0.5,0.7');
      if (window.duoLayers) window.duoLayers(root.parentNode || document);
    }
    at();
    if (mq.addEventListener) mq.addEventListener('change', at); else if (mq.addListener) mq.addListener(at);
  })();

  /* ---------- the cut-off line: the real next delivery day (beside the tabs, and under them on small screens) ---------- */
  (function cutLine() {
    // only while ordering is open and delivery is confirmed (the section prints data-on="truetrue")
    var els = root.querySelectorAll('[data-duo-cutline][data-on="truetrue"]');
    if (!els.length || !window.duoDeliveryNext) return;
    var n = window.duoDeliveryNext();
    if (!n) return;
    var h = n.cut % 24, hh = h === 0 ? '12 am' : h < 12 ? h + ' am' : h === 12 ? '12 pm' : (h - 12) + ' pm';
    // the cut-off is the night before the delivery day (Theme settings > DUO > Delivery)
    var day = n.away <= 6 ? n.label.split(',')[0] : n.label;
    var eve = new Date(Date.parse(n.iso + 'T12:00:00Z') - 864e5).toLocaleDateString('en-CA', { timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric' });
    var when = n.away === 1 ? 'tonight' : n.away === 2 ? 'tomorrow night' : n.away <= 6 ? eve.split(',')[0] + ' night' : eve;
    var line = 'Order by ' + hh + ' ' + when + ', at your door ' + day + (n.window ? ', ' + n.window : '') + '.';
    Array.prototype.forEach.call(els, function (el) { el.querySelector('span').textContent = line; el.hidden = false; });
  })();

  /* ---------- the drink: builds, Plus Ones, caffeine, price, cart lines ---------- */
  function State(key) {
    var d = D.drinks[key];
    this.d = d;
    this.m = MENUS[d.menu] || { p1: [], build: '' };
    this.b = d.builds[0];
    this.picked = [];
    this.qty = 1;
    this.id = '';
  }
  State.prototype.version = function () { return this.b ? this.b.v : 'low'; };
  State.prototype.offered = function () {
    var self = this;
    return (this.m.p1 || []).map(p1).filter(function (a) {
      if (!a || a.cf) return false;
      if (a.build && a.build !== self.version()) return false;
      if (a.mg && (self.b.cf || self.b.nocaf || !self.b.mg)) return false;
      return true;
    });
  };
  State.prototype.extras = function () {
    var ok = this.offered().map(function (a) { return a.handle; });
    this.picked = this.picked.filter(function (h) { return ok.indexOf(h) > -1; });
    return this.picked.map(p1).filter(Boolean);
  };
  State.prototype.mg = function () {
    var mg = this.b.mg || 0;
    this.extras().forEach(function (a) { mg += a.mg || 0; });
    return mg;
  };
  State.prototype.label = function (a) { return a.handle === 'extra-flavour' && this.d.swirl ? this.d.swirl + ' swirl' : a.name; };
  State.prototype.buildWord = function () {
    if (this.d.build) return this.d.build;
    return this.b.nocaf ? '' : NAME[this.b.v] || '';
  };
  State.prototype.recipe = function (n) {
    var self = this, ex = this.extras().map(function (a) { return self.label(a); });
    if (this.b.cf) ex.unshift('Caffeine free');
    var r = [[this.d.name, this.buildWord()].filter(Boolean).join(' · ')].concat(ex).join(' + ');
    n = n || this.qty;
    return n > 1 ? n + ' x ' + r : r;
  };
  State.prototype.perCan = function () {
    return (this.b.price || 0) + this.extras().reduce(function (s, a) { return s + (a.price || 0); }, 0);
  };
  /* the lines, as assets/duo-builder.js writes them */
  State.prototype.items = function (n) {
    var self = this, extras = this.extras(), props = {};
    var buildTxt = this.b.nocaf ? 'Caffeine free' : (NAME[this.b.v] || '') + (this.b.cf ? ', caffeine free' : '');
    props[this.b.cf ? 'Build' : '_Build'] = buildTxt;
    if (extras.length) props['Plus Ones'] = extras.map(function (a) { return self.label(a); }).join(', ');
    var sw = extras.some(function (a) { return a.handle === 'extra-flavour'; }) && this.d.swirl;
    if (sw) props['Swirl'] = this.d.swirl;
    props['Caffeine'] = Math.round(this.mg()) + ' mg';
    props['_Recipe'] = this.recipe(n);
    props['_build'] = this.id;
    var items = [{ id: Number(this.b.id), quantity: n, properties: props }];
    extras.forEach(function (a) {
      if (!a.id) return;
      var pp = { 'Mixed into': self.d.name, '_build': self.id };
      if (a.handle === 'extra-flavour' && self.d.swirl) pp['Swirl'] = self.d.swirl;
      items.push({ id: Number(a.id), quantity: n, properties: pp });
    });
    return items;
  };

  /* "Add 3 Plus Ones: one is on us" (Shopify's automatic discount): what this add takes off, so the
     button says what the cart will charge (the same sum as Builder.prototype.p1Bonus). */
  var cartP1 = { n: 0, m: 0 };
  function readCartP1() {
    if (!D.offer || !SEE) return Promise.resolve();
    return cartJs().then(function (c) {
      var n = 0, m = 0;
      (c.items || []).forEach(function (i) {
        if (i.product_type !== 'Plus One') return;
        var pr = i.original_price || i.price || 0;
        if (!pr || !i.quantity) return;
        n += i.quantity; if (!m || pr < m) m = pr;
      });
      cartP1 = { n: n, m: m };
    }).catch(function () {});
  }
  function bonus(st) {
    if (!D.offer || !SEE) return { off: 0, units: 0 };
    var n = 0, m = 0;
    st.extras().forEach(function (a) { if (a.price > 0) { n += st.qty; if (!m || a.price < m) m = a.price; } });
    var before = cartP1.n >= 3 ? cartP1.m : 0;
    var low = cartP1.n && n ? Math.min(cartP1.m, m) : (cartP1.n ? cartP1.m : m);
    var after = cartP1.n + n >= 3 ? low : 0;
    return { off: n ? after - before : 0, units: cartP1.n + n };
  }

  /* ---------- the sheet ---------- */
  var sheet = $('[data-duo-msheet]');
  var panel = sheet.querySelector('.duo-msheet__panel');
  var vDrink = sheet.querySelector('[data-view="drink"]');
  var vDone = sheet.querySelector('[data-view="done"]');
  var S = null, lastFocus = null, openedByPush = false;
  function q(sel) { return sheet.querySelector(sel); }

  /* v3: the drink is its cut-out on its split colour (snippets/duo-split.liquid gives d.sp, the box's
     --sp-* vars; .duo-split in assets/duo.css places the can and the seam). No cut-out: its colour + name. */
  function photo(el, d) {
    el.innerHTML = '';
    el.setAttribute('style', d.sp || '');
    el.classList.toggle('is-tile', !d.cut);
    if (d.cut) {
      var i = document.createElement('img');
      i.src = d.cut; i.alt = ''; i.className = 'duo-split__can'; i.decoding = 'async'; i.draggable = false;
      el.appendChild(i);
    } else {
      el.innerHTML = '<span class="duo-mcard__tile"><b></b></span>';
      el.querySelector('b').textContent = d.name;
    }
  }

  function drawDrink() {
    var st = S, d = st.d;
    sheet.style.setProperty('--c', d.c);
    sheet.style.setProperty('--t', d.t);
    photo(q('[data-m-img]'), d);
    q('[data-m-menu]').textContent = st.m.name || '';
    q('[data-m-name]').textContent = d.name;
    q('[data-m-flav]').textContent = d.flav;
    // builds: only when there is a choice
    var bw = q('[data-m-builds-wrap]'), bx = q('[data-m-builds]');
    bx.innerHTML = '';
    bw.hidden = d.builds.length < 2;
    bx.style.setProperty('--n', String(d.builds.length));
    d.builds.forEach(function (b) {
      var x = document.createElement('button');
      x.type = 'button'; x.className = 'duo-mseg__b'; x.dataset.k = b.k;
      // the price on its own line (members), so "About 125 mg" never wraps it onto a third line in one pill only
      x.innerHTML = '<b></b><small></small>' + (SEE && b.price ? '<span class="duo-mseg__p"></span>' : '');
      x.querySelector('b').textContent = b.label;
      x.querySelector('small').textContent = b.sub;
      if (SEE && b.price) x.querySelector('.duo-mseg__p').textContent = money(b.price);
      x.addEventListener('click', function () { st.b = b; render(); });
      bx.appendChild(x);
    });
    // Plus Ones: her menu's, in its order, at most four
    var px = q('[data-m-p1]');
    px.innerHTML = '';
    (st.m.p1 || []).slice(0, 4).map(p1).filter(Boolean).forEach(function (a) {
      var x = document.createElement('button');
      x.type = 'button'; x.className = 'duo-mp1__b'; x.dataset.p1 = a.handle;
      x.innerHTML = '<span>' + (a.img ? '<img alt="" width="48" height="48" loading="lazy">' : '') + '</span><span><strong></strong><small></small></span>';
      if (a.img) x.querySelector('img').src = a.img;
      x.querySelector('strong').textContent = a.handle === 'extra-flavour' && d.swirl ? 'Flavour swirl' : a.name;
      x.addEventListener('click', function () {
        if (x.getAttribute('aria-disabled') === 'true') return;
        var i = st.picked.indexOf(a.handle);
        if (i > -1) st.picked.splice(i, 1); else st.picked.push(a.handle);
        render();
      });
      px.appendChild(x);
    });
    q('[data-m-p1-wrap]').hidden = !px.children.length;
    // What's in it
    var ings = q('[data-m-ings]'), tpl = root.querySelector('template[data-duo-ings="' + d.key + '"]');
    ings.innerHTML = '';
    if (tpl) ings.appendChild(tpl.content.cloneNode(true));
    q('.duo-msheet__ings').open = false;
    var pg = q('[data-m-page]');
    q('[data-m-page-wrap]').hidden = !d.url;
    if (d.url) pg.href = d.url;
    q('[data-m-note]').textContent = '';
    render();
  }

  function render() {
    var st = S, d = st.d;
    Array.prototype.forEach.call(q('[data-m-builds]').children, function (x) { x.setAttribute('aria-pressed', String(x.dataset.k === st.b.k)); });
    var ex = st.extras(), offered = st.offered().map(function (a) { return a.handle; });
    var mg = st.mg();
    var vis = [];
    Array.prototype.forEach.call(q('[data-m-p1]').children, function (x) {
      var a = p1(x.dataset.p1), on = st.picked.indexOf(a.handle) > -1;
      x.hidden = offered.indexOf(a.handle) < 0;
      x.classList.remove('is-span');
      if (!x.hidden) vis.push(x);
      var over = !on && a.mg && mg + a.mg > D.cap;
      x.setAttribute('aria-pressed', String(on));
      x.setAttribute('aria-disabled', over ? 'true' : 'false');
      var sm = x.querySelector('small');
      sm.textContent = over ? 'Over the ' + D.cap + ' mg cap' : [SEE && a.price ? '+' + money(a.price) : '', a.note || ''].filter(Boolean).join(' · ');
    });
    if (vis.length % 2) vis[vis.length - 1].classList.add('is-span');
    // a fact line for each one she adds, any caution in bold (snippets/duo-plusones.liquid)
    var facts = q('[data-m-facts]');
    facts.innerHTML = '';
    ex.forEach(function (a) {
      var li = document.createElement('li');
      var b = document.createElement('b'); b.textContent = st.label(a) + '. ';
      li.appendChild(b);
      li.appendChild(document.createTextNode((a.fact || '') + ' '));
      if (a.warn && !(a.handle === 'rizz-shot' && st.b.v === 'high')) { var w = document.createElement('b'); w.textContent = a.warn; li.appendChild(w); }
      facts.appendChild(li);
    });
    var bo = bonus(st);
    var sum = ex.length ? ex.map(function (a) { return st.label(a); }).join(', ') : 'Optional';
    if (D.offer && SEE) {
      var left = 3 - bo.units;
      if (bo.off > 0) sum += ' · ' + money(bo.off) + ' on us';
      else if (left > 0 && ex.length) sum += ' · ' + left + ' more, one is on us';
    }
    q('[data-m-p1sum]').textContent = sum;
    q('[data-m-mg]').textContent = (st.buildWord() ? st.buildWord() + (st.b.cf ? ', caffeine free' : '') + ' · ' : '') + (mg ? 'About ' + mg + ' mg caffeine' : '0 mg caffeine');
    // how many: the 6 says "Delivery on us" when six of this build get there (a public line)
    Array.prototype.forEach.call(q('[data-m-qty]').children, function (x) { x.setAttribute('aria-pressed', String(+x.dataset.qty === st.qty)); });
    q('[data-m-sixtag]').hidden = !st.b.six;
    // the kick's own label caution, where she decides
    var warn = q('[data-m-warn]');
    var kicked = st.b.v === 'high';
    var caution = d.caution || st.m.caution || '';
    warn.hidden = !(kicked || caution);
    warn.textContent = kicked
      ? 'The kick: adults 19+. Not if you\'re pregnant, breastfeeding or sensitive to caffeine, and not with coffee, other caffeine or alcohol.'
      : caution;
    var total = st.perCan() * st.qty - bo.off;
    q('[data-m-price]').textContent = SEE && total > 0 ? money(total) : '';
    q('[data-m-addlabel]').textContent = D.open === false ? 'Save my drink' : st.qty > 1 ? 'Add ' + st.qty + ' cans' : 'Add';
  }
  q('[data-m-qty]').addEventListener('click', function (e) {
    var x = e.target.closest('[data-qty]');
    if (!x || !S) return;
    S.qty = +x.dataset.qty;
    render();
  });

  function show(view) {
    vDrink.hidden = view !== 'drink';
    vDone.hidden = view !== 'done';
  }
  function scrollbarW() { return window.innerWidth - document.documentElement.clientWidth; }
  function openSheet(view) {
    if (sheet.hidden) {
      lastFocus = document.activeElement;
      var sw = scrollbarW();
      document.documentElement.style.overflow = 'hidden';
      if (sw) document.documentElement.style.paddingRight = sw + 'px';
      sheet.hidden = false;
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
    }
    show(view);
    var sc = (view === 'done' ? vDone : vDrink).querySelector('.duo-msheet__scroll');
    if (sc) sc.scrollTop = 0;
    var f = view === 'done' ? q('[data-d-h]') : panel;
    try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
  }
  function closeSheet(fromPop) {
    if (sheet.hidden) return;
    sheet.classList.remove('is-open');
    var done = function () {
      sheet.hidden = true;
      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = '';
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* fine */ }
    };
    if (calm) done(); else setTimeout(done, 220);
    if (!fromPop && openedByPush) { openedByPush = false; history.back(); }
  }
  function openDrink(key, push) {
    if (!D.drinks[key]) return;
    S = new State(key);
    drawDrink();
    openSheet('drink');
    readCartP1().then(function () { if (S && !vDrink.hidden) render(); });
    if (push) {
      var qs = new URLSearchParams(location.search);
      qs.set('drink', key);
      qs.set('menu', D.drinks[key].menu);
      history.pushState({ duoDrink: key }, '', location.pathname + '?' + qs.toString());
      openedByPush = true;
    }
  }
  sheet.addEventListener('click', function (e) { if (e.target.closest('[data-duo-mclose]')) closeSheet(false); });
  // the page behind stays put while the sheet is open (the scrim takes the wheel and the touch)
  var scrim = sheet.querySelector('.duo-msheet__scrim');
  ['wheel', 'touchmove'].forEach(function (ev) { scrim.addEventListener(ev, function (e) { e.preventDefault(); }, { passive: false }); });
  document.addEventListener('keydown', function (e) {
    if (sheet.hidden) return;
    if (e.key === 'Escape') { closeSheet(false); return; }
    if (e.key !== 'Tab') return;
    // keep focus inside the open sheet
    var view = vDone.hidden ? vDrink : vDone;
    var f = Array.prototype.filter.call(sheet.querySelectorAll('button,a[href],summary,[tabindex="-1"]'), function (x) {
      return !x.closest('[hidden]') && (view.contains(x) || x.classList.contains('duo-msheet__x')) && x.offsetParent !== null;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.addEventListener('popstate', function () {
    var qs = new URLSearchParams(location.search);
    setMenu(qs.get('menu') || keys()[0], false);
    var k = qs.get('drink');
    if (k && D.drinks[k]) { if (sheet.hidden) openDrink(k, false); }
    else { openedByPush = false; closeSheet(true); }
  });

  /* ---------- adding ---------- */
  function rememberUsual(st, items) {
    try {
      localStorage.setItem('duo:last', JSON.stringify({ source: 'last', items: items, recipe: st.recipe(), fruit: null, little: '', url: st.d.url || '/collections?menu=' + st.d.menu, at: Date.now() }));
    } catch (e) { /* private mode: fine */ }
  }
  function keepPending(addIds, addItems, dropId) {
    if (!GUEST) return;
    var p = readPending() || { ids: [], items: [] };
    var items = dropId ? p.items.filter(function (i) { return !(i.properties && i.properties._build === dropId && i.properties['Paired with'] === undefined); }) : p.items;
    var ids = p.ids.slice();
    addIds.forEach(function (x) { if (ids.indexOf(x) < 0) ids.push(x); });
    writePending({ ids: ids, items: items.concat(addItems), at: Date.now() });
  }
  /* "Ordering open" off: the sheet's button takes her build to the drink page with the email box open. */
  function saveUrl(st) {
    var qs = ['save=1'], ex = st.extras().map(function (a) { return a.handle; });
    if (st.b.v === 'low' || st.b.v === 'high') qs.push('key=' + st.b.v);
    if (st.b.cf) P1.forEach(function (a) { if (a.cf) ex.unshift(a.handle); });
    if (ex.length) qs.push('p1=' + ex.map(encodeURIComponent).join(','));
    if (st.qty > 1) qs.push('n=' + st.qty);
    return st.d.url + '?' + qs.join('&');
  }
  function add(st, btn) {
    if (btn.classList.contains('is-busy')) return;
    if (D.open === false) { if (st.d.url) window.location.href = saveUrl(st); return; }
    st.id = buildId();
    var note = vDrink.hidden ? null : q('[data-m-note]');
    if (!st.d.live) {
      // preview: a Draft drink runs the whole flow and touches nothing
      st.preview = true;
      done(st);
      return;
    }
    if (!st.b.id) return;
    btn.classList.add('is-busy');
    var items = st.items(st.qty);
    // Shopify puts the newest line on top: post backwards so the cart reads drink, then its Plus Ones
    post('/cart/add.js', { items: items.slice().reverse() })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Could not add that. Try again.');
        document.dispatchEvent(new CustomEvent('duo:added', { detail: { items: items } }));
        keepPending([st.id], items);
        rememberUsual(st, items);
        cartJs().then(headerCount).catch(function () {});
        done(st);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        if (note) note.textContent = err.message;
        else {
          // a card's + (a round icon button): say it in the card, under its words
          var n = btn.closest('.duo-mcard');
          if (n) {
            var e = n.querySelector('.duo-mcard__err');
            if (!e) { e = document.createElement('p'); e.className = 'duo-mcard__err'; e.setAttribute('role', 'status'); n.querySelector('.duo-mcard__body').appendChild(e); }
            e.textContent = err.message || 'Could not add that. Try again.';
          }
        }
      });
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-duo-madd]');
    if (a) { e.preventDefault(); var st = new State(a.dataset.duoMadd); add(st, a); return; }
    var o = e.target.closest('[data-duo-mopen]');
    if (o) { e.preventDefault(); openDrink(o.dataset.duoMopen, true); }
  });
  q('[data-m-add]').addEventListener('click', function () { if (S) add(S, this); });

  /* ---------- the confirmation ---------- */
  var DONE = null;
  function done(st) {
    DONE = st;
    S = st;
    var d = st.d;
    sheet.style.setProperty('--c', d.c);
    sheet.style.setProperty('--t', d.t);
    photo(q('[data-d-img]'), d);
    q('[data-d-h]').textContent = st.preview ? 'Your drink.' : 'It\'s in your cart.';
    q('[data-d-preview]').hidden = !st.preview;
    q('[data-d-name]').textContent = (st.qty > 1 ? st.qty + ' x ' : '') + d.name;
    var ex = st.extras();
    q('[data-d-recipe]').textContent = [st.buildWord() + (st.b.cf ? ', caffeine free' : ''), Math.round(st.mg()) + ' mg caffeine'].filter(Boolean).join(' · ') + (ex.length ? ' · + ' + ex.map(function (a) { return st.label(a); }).join(', ') : '');
    q('[data-d-note]').textContent = '';
    // six cans: hers filled in, the rest one tap away (only when six of this build reach delivery on us)
    var six = q('[data-d-six]'), cans = q('[data-d-cans]'), more = q('[data-d-more]');
    six.hidden = !(st.b.six && st.qty < 6);
    cans.innerHTML = '';
    cans.setAttribute('style', d.sp || '');   // her cans fill with the drink's own bottom colour
    for (var i = 0; i < 6; i++) { var c = document.createElement('i'); if (i < st.qty) c.className = 'is-on'; cans.appendChild(c); }
    more.disabled = false; more.classList.remove('is-done', 'is-busy');
    q('[data-d-more-label]').textContent = 'Add ' + (6 - st.qty) + ' more';
    more.querySelector('span').textContent = 'Delivery is on us';
    // one for them: a Little DUO, one tap
    var lit = q('[data-d-little]'), L = d.little;
    lit.hidden = !L;
    if (L) {
      var li = q('[data-d-limg]');
      lit.style.setProperty('--lc', L.c || '#FF6F4D');
      li.innerHTML = L.img ? '<img alt="" width="48" height="48">' : '';
      if (L.img) li.querySelector('img').src = L.img;
      q('[data-d-lname]').textContent = L.name + ', 250 ml, 0 mg caffeine';
      var lb = q('[data-d-ladd]');
      lb.disabled = false; lb.classList.remove('is-done', 'is-busy');
      q('[data-d-ladd-label]').textContent = 'Add';
      q('[data-d-lprice]').textContent = SEE && L.price ? '+' + money(L.price) : '';
    }
    openSheet('done');
  }
  function doneNote(t) { q('[data-d-note]').textContent = t; }
  q('[data-d-more]').addEventListener('click', function () {
    var st = DONE, btn = this;
    if (!st || btn.disabled) return;
    var finish = function () {
      st.qty = 6;
      Array.prototype.forEach.call(q('[data-d-cans]').children, function (c) { c.className = 'is-on'; });
      q('[data-d-name]').textContent = '6 x ' + st.d.name;
      btn.disabled = true; btn.classList.add('is-done');
      q('[data-d-more-label]').textContent = 'Six cans';
      btn.querySelector('span').textContent = 'Delivery is on us';
    };
    if (st.preview) { finish(); return; }
    btn.classList.add('is-busy');
    // the same build at six cans: her lines out, the six in, same _build (the drink page's edit)
    var items = st.items(6);
    cartJs().then(function (c) {
      var up = {};
      (c.items || []).forEach(function (i) { if (i.properties && i.properties._build === st.id && i.product_type !== 'Little DUO') up[i.key] = 0; });
      return post('/cart/update.js', { updates: up });
    }).then(function (r) {
      if (!r.ok) throw new Error('x');
      return post('/cart/add.js', { items: items.slice().reverse() });
    }).then(function (r) {
      btn.classList.remove('is-busy');
      if (!r.ok) throw new Error('x');
      document.dispatchEvent(new CustomEvent('duo:added', { detail: { items: items } }));
      keepPending([st.id], items, st.id);
      rememberUsual(st, items);
      cartJs().then(headerCount).catch(function () {});
      finish();
    }).catch(function () {
      btn.classList.remove('is-busy');
      doneNote('Could not add the five. Your first can is still in your cart.');
    });
  });
  q('[data-d-ladd]').addEventListener('click', function () {
    var st = DONE, btn = this, L = st && st.d.little;
    if (!L || btn.disabled) return;
    var finish = function () { btn.disabled = true; btn.classList.add('is-done'); q('[data-d-ladd-label]').textContent = 'Added'; q('[data-d-lprice]').textContent = ''; };
    if (st.preview) { finish(); return; }
    btn.classList.add('is-busy');
    var item = { id: Number(L.id), quantity: 1, properties: { 'Paired with': st.d.name, '_build': st.id } };
    post('/cart/add.js', { items: [item] }).then(function (r) {
      btn.classList.remove('is-busy');
      if (!r.ok) throw new Error('x');
      document.dispatchEvent(new CustomEvent('duo:added', { detail: { items: [item] } }));
      keepPending([st.id], [item]);
      cartJs().then(headerCount).catch(function () {});
      finish();
    }).catch(function () { btn.classList.remove('is-busy'); doneNote('Could not add the Little DUO. Try again.'); });
  });
  var co = q('[data-d-checkout]');
  if (co) co.addEventListener('click', function () {
    if (DONE && DONE.preview) { doneNote('Preview: nothing is in the cart for this drink.'); return; }
    co.classList.add('is-busy');
    // under the smallest order we deliver, checkout offers no delivery: the cart says what's missing
    var min = window.DUO_DELIVERY && +window.DUO_DELIVERY.min || 0;
    cartJs().then(function (c) { window.location.href = min && c.total_price < min ? '/cart' : '/checkout'; }, function () { window.location.href = '/cart'; });
  });
  var si = q('[data-d-signin]');
  if (si) si.addEventListener('click', function () {
    if (DONE && DONE.preview) { doneNote('Preview: nothing is in the cart for this drink.'); return; }
    si.classList.add('is-busy');
    signIn('/cart');
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) Array.prototype.forEach.call(root.querySelectorAll('.is-busy'), function (b) { b.classList.remove('is-busy'); }); });

  /* opened from a link: ?drink=<key> */
  (function () {
    var k = new URLSearchParams(location.search).get('drink');
    if (k && D.drinks[k]) openDrink(k, false);
  })();
})();
